import qs from 'qs';

import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';

export interface TimeInterval {
  start_time: string; // ISO 8601 format
  end_time: string; // ISO 8601 format
}

export interface AvailabilitySlotDay {
  date_label: string; // e.g., "Today Friday, Jul 4"
  date: string; // e.g., "2025-07-04"
  sync_time_slots: string[]; // e.g., ["09:00", "09:30"]
  sync_time_intervals: TimeInterval[];
  async_time_slots: string[];
  async_time_intervals: TimeInterval[];
}

export interface ListAvailabilityTimeSlotsResponse {
  id: number;
  created_at: string;
  updated_at?: string;
  user: any;
  in_network: boolean;
  days: AvailabilitySlotDay[];
  has_next_page: boolean;
  end_cursor?: string;
}

export interface ListAvailabilityTimeSlotsParams {
  limit?: number;
  cursor?: string;
  tz?: string;
  date?: string; // e.g., "2025-07-04"
}

/**
 * Get availability time slots grouped by date for a given provider.
 * Uses a role-scoped API prefix (e.g. /collector, /care_advisor) so staff
 * roles reach the correct backend router instead of the patient-facing one.
 */
export const listProviderAvailabilityTimeSlots = async (
  providerId: number,
  params?: ListAvailabilityTimeSlotsParams,
  userRole?: string,
): Promise<ListAvailabilityTimeSlotsResponse> => {
  const prefix = getStaffScopedApiPrefix(userRole) || '/patients';
  const query = qs.stringify(params, { skipNulls: true });
  const { data } = await client.get(`${prefix}/provider_availabilities/${providerId}?${query}`);
  return data;
};
